import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/portfolio-frontend/src/components/Header.tsx");
